<div class="container-fluid">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="fs-4 fw-bold">
          Date Wise {{ type === "Tracker" ? "Tracker" : "LR" }} Expense Report :
          {{ month }} {{ year }}
        </h1>

        <button
          class="btn btn-dark btn-sm"
          mat-raised-button
          matTooltip="Back"
          matTooltipPosition="left"
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="contentbox mt-3">
    <div class="row customepadding">
      <div class="col-md-12 table-responsive">
        <table
          datatable
          class="row-border hover tablelist"
          *ngIf="LrExpenseArray.length > 0"
        >
          <thead>
            <tr>
              <td>Date</td>
              <!-- <td>Company Name</td>
              <td>Supervisor Name</td> -->
              <td>LR Number</td>
              <td>Vehicle Number</td>
              <td>From</td>
              <td>To</td>
              <td>Labour Loading</td>
              <td>Labour unloading</td>
              <td>Other Payment</td>
              <td>Detention</td>
              <td>Vehicle Rate</td>
              <td>Advance</td>
              <td>Balance Paid</td>
              <td>Actual Balance</td>
              <td>Total Expense</td>
            </tr>
          </thead>
          <tbody>
            <tr class="text-center" *ngFor="let LrExpense of LrExpenseArray">
              <td>{{ LrExpense?.date | date: "dd/MM/yyyy" }}</td>
              <!-- <td>{{ LrExpense?.companyName }}</td>
              <td>{{ LrExpense?.supervisorName }}</td> -->
              <td>
                {{
                  LrExpense.manualLR_no
                    ? LrExpense.manualLR_no
                    : LrExpense.LR_no
                }}
              </td>
              <td>{{ LrExpense?.vehicle_id }}</td>
              <td>{{ LrExpense?.from }}</td>
              <td>{{ LrExpense?.to }}</td>
              <td>{{ LrExpense?.labourLoad }}</td>
              <td>{{ LrExpense?.labourUnload }}</td>
              <td>{{ LrExpense?.otherPayment }}</td>
              <td>{{ LrExpense?.detention }}</td>
              <td>{{ LrExpense?.vehicleRate }}</td>
              <td>{{ LrExpense?.advance }}</td>
              <td>{{ LrExpense?.balancePaid }}</td>
              <td>{{ LrExpense?.balance }}</td>
              <td>{{ LrExpense?.totalExpense }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
